export default "__VITE_ASSET__DmU1Uto0__"